export default __webpack_public_path__ + "static/media/melukis.66e86f25.png";